import React from 'react'
import { useFeedBackGet } from '../../../intake/intakeQueries';
import { Button, Dialog, DialogContent, Grid, LinearProgress, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { formatDate } from '../../../common/formatDate';
import { generalFilter, useDefaultColumn } from '../../../../util/filter';
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import { renderHeader } from '../../../common/util';
import ScreenWidth from '../../../common/ScreenWidth';
import MuiTable from "@material-ui/core/Table";
import { FeedBackTableview } from './FeedBackTableview';


export const FeedBackGrid = () => {

    

    const [open, setOpen] = React.useState(false);
    const [selectedFiles, setSelectedFiles] = React.useState<any[]>([]);

    const {
        data: FeedBackData,
        isError: isErrorFeedBackData,
        isLoading: isLoadingFeedBackData,
        error: errorFeedBackData,
    } = useFeedBackGet();



    

    if (isLoadingFeedBackData) {
        return <LinearProgress />
    }

    return (
        <>
            <div>
                {FeedBackData &&(
                    <FeedBackTableview FeedBackData={FeedBackData.results} />
                )}
            </div>


        </>
    )
}


